import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetCountNotificationsByOrdersInput } from './GetCountNotificationsByOrdersInput';
import { GetCountNotificationsByOrdersOutput } from './GetCountNotificationsByOrdersOutput';

export class GetCountNotificationsByOrdersService extends HttpServiceBase {

  handle = (input: GetCountNotificationsByOrdersInput): Promise<Result<GetCountNotificationsByOrdersOutput> | null> => {
    const promise = this.http.post<Result<GetCountNotificationsByOrdersOutput>, GetCountNotificationsByOrdersInput>(
      `${this.baseUrlSislogApi}/v2/recipe/notification/count-by-orders`,
      input
    );
    return promise;
  }
}